import { render, staticRenderFns } from "./BillPanel.vue?vue&type=template&id=be3254ba&scoped=true&"
import script from "./BillPanel.vue?vue&type=script&lang=js&"
export * from "./BillPanel.vue?vue&type=script&lang=js&"
import style0 from "./BillPanel.vue?vue&type=style&index=0&id=be3254ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3254ba",
  null
  
)

export default component.exports